import styled from 'styled-components';

export const NoResultsCard = styled.div`
  background: white;
  border-radius: 0.4rem;
  padding: 4rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 3.8rem;
`;
export const ResetButton = styled.button`
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  padding: 1rem;
  outline: 0;
  border: 0;
  background: #ff6d38;
  border-radius: 0.4rem;
  width: 32rem;
  cursor:pointer;
`;
export const SmallText = styled.p`
  color: #4f525a;
  font-size: 1.4rem;
  line-height: 1.2;
  padding-bottom: 4rem;
`;
export const ErrorMsg = styled.p`
  font-size: 1.6rem;
  color: #2276e3;
  font-weight: bold;
  padding-top: 2rem;
  padding-bottom: 1rem;
`;
